import { fork, call, put, takeLatest } from 'redux-saga/effects';

import {
	CHATBOT_TOKEN_REQUESTING,
	CHATBOT_TOKEN_SUCCESS,
	CHATBOT_TOKEN_ERROR,
} from '@/redux/ducks/chatBot/types';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import Api from '@/data';
import { getObjValue } from '@/utils/helper';

export function* getChatBotToken() {
	try {
		const response = yield call(Api.getChatBotToken);
		yield put({
			type: CHATBOT_TOKEN_SUCCESS,
			data: getObjValue(response, 'data.token'),
		});
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: CHATBOT_TOKEN_ERROR, error: error.data });
		}
	}
}

export function* getChatBotTokenWatcher() {
	yield takeLatest(CHATBOT_TOKEN_REQUESTING, getChatBotToken);
}

function* chatBotSaga() {
	yield fork(getChatBotTokenWatcher);
}

export default chatBotSaga;
